    import { FormControlLabel, RadioGroup, FormLabel, Box, Radio } from '@mui/material';
    import { useState, useEffect, React } from 'react';
    import PropTypes from 'prop-types';

    const BooleanEntry = ({ name, onChange, value }) => {
        const [selectedValue, setSelectedValue] = useState(value?.toString() || "");

        useEffect(() => {
            if (value !== undefined) {
                setSelectedValue(value.toString());
            }
        }, [value]);

        const handleChange = (event) => {
            const newValue = event.target.value;
            setSelectedValue(newValue);
            if (onChange) {
                onChange(newValue);
            }
        };

        return (
            <Box marginTop={1}>
                <FormLabel component="legend" sx={{ color: 'black' }}>{name}</FormLabel>
                <RadioGroup 
                    row 
                    value={selectedValue}
                    onChange={handleChange}
                >
                    <FormControlLabel value="true" control={<Radio />} label="True" />
                    <FormControlLabel value="false" control={<Radio />} label="False" />
                </RadioGroup>
            </Box>
        );
    };

    BooleanEntry.propTypes = {
        name: PropTypes.any,       
        onChange: PropTypes.func,         
        value: PropTypes.any,
    };

    export default BooleanEntry;